var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConnectDomain = function SvgConnectDomain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#connectDomain_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "connectDomain_svg__b",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120 0H0v120h120V0Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#connectDomain_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.05 95H13.8l2.3-66.212h91.262L105.05 95Z",
    fill: "#C2E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.312 30h-91.25l.263-7.5h91.25l-.263 7.5Z",
    fill: "#116DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m114.9 53.337-79.675 29.25L24.9 54.826l79.675-29.25L114.9 53.337Z",
    fill: "#28BF9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m56.341 52.318 1.34 13.626-2.533.943-5.686-8.056.967 9.813-2.515.936-7.915-11.177 2.515-.936 5.61 8.539-.978-10.264 2.1-.782 6.042 8.536-1.375-10.273 2.428-.905Zm17.315-6.447 1.34 13.626-2.534.943-5.686-8.056.968 9.813-2.516.937-7.915-11.178 2.515-.936 5.61 8.54-.977-10.265 2.099-.782 6.043 8.536-1.376-10.273 2.429-.905Zm17.314-6.446 1.34 13.625-2.533.943-5.687-8.056.968 9.813-2.516.937-7.915-11.177 2.516-.937 5.609 8.54-.977-10.265 2.1-.781 6.042 8.536-1.376-10.274 2.429-.904ZM22.107 25.357c.474.482.452 1.274-.05 1.767-.503.494-1.294.503-1.768.02-.475-.482-.452-1.274.05-1.767.503-.494 1.294-.503 1.768-.02Zm5.004-.005c.474.483.451 1.274-.05 1.767-.503.494-1.294.503-1.769.02-.474-.482-.451-1.273.051-1.767s1.294-.502 1.768-.02Zm4.991-.004c.475.482.452 1.274-.05 1.767-.503.494-1.294.503-1.768.02-.475-.483-.452-1.274.05-1.768.503-.493 1.294-.502 1.768-.02Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.38 75.684.766.987L8.703 91.763l-.766-.987 19.442-15.092Zm-2.953-5.794.408 1.182-17.157 5.92-.408-1.181 17.157-5.921Zm79.035-57.39a9.597 9.597 0 0 1 6.975 2.925 9.47 9.47 0 0 1 2.65 6.988 10.337 10.337 0 0 1-10.275 9.862v-1.25a9.074 9.074 0 0 0 9.025-8.662 8.248 8.248 0 0 0-2.3-6.113 8.387 8.387 0 0 0-6.075-2.5 9.075 9.075 0 0 0-9.025 8.663h-1.25a10.337 10.337 0 0 1 10.275-9.913Z",
    fill: "#192C55"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "connectDomain_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h120v120H0z"
  })))));
};
export default SvgConnectDomain;